import React from 'react';
import ImageComparisonSlider from '../common/ImageComparisonSlider';
import beforeImage from '../../assets/img/about/before.png';
import afterImage from '../../assets/img/about/after.png';

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-text">
        <h2 className="about-title">
          <span className="text-primary">Point Cloud to</span> M and Scan to Revit Services for USA Projects
        </h2>
        <p>
          We convert laser scans and point cloud data into precise BIM models for architects, contractors, and design teams across the USA.  Scan to BIM service company is a leading Point cloud Scan to BIM service and BIM modeling company based in the USA, specializing in a comprehensive range of Architectural BIM outsourcing solutions.
        </p>
        <p>
          Our services include Scan to BIM Modeling, Point Cloud to BIM, 3D Modeling, CAD to BIM, Point Cloud to CAD,  Point Cloud To Revit, Revit family creation,  Scan to CAD Conversion, Clash Detection, MEP Scan to BIM, BIM Facility Management, PDF to Revit conversion, CAD Drawing Drafting, CD Set Drawings, As-Built CAD Drafting, MEP  (Mechanical, Electrical, Plumbing).
        </p>
        <p>
          With a team of award-winning Dedicated Scan to BIM modelers, Professional CAD drafters, and BIM-certified architecture experts, we are your one-stop destination for all Scan to BIM and Scan to CAD needs in the USA. We are dedicated to delivering high-quality Scan-to-BIM projects that align with your company’s goals, ensuring 99% client satisfaction worldwide. Choose Scan to BIM Service Company for reliable and efficient Point Cloud to BIM and CAD services that drive success in your projects.
        </p>
      </div>
      <div className="about-image-wrapper">
        <ImageComparisonSlider
          beforeImage={beforeImage.src || beforeImage}
          afterImage={afterImage.src || afterImage}
        />
      </div>
    </section>
  );
};

export default AboutSection;
